import React from "react";
import { useTranslation } from "react-i18next";

/** Inline sold stamp — sits beside the title, never on the artwork. */
export function CanvasSoldLabel({ className = "" }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full bg-canvas-100/90 px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.14em] text-canvas-500 ring-1 ring-canvas-200/70 ${className}`}
      aria-label={t("canvas.sold.status")}
    >
      {t("canvas.sold.badge")}
    </span>
  );
}
